// extracted by mini-css-extract-plugin
export default {"div":"Timer_div__1U37H","h2":"Timer_h2__3WNCk","div2":"Timer_div2__kn8-F","step":"Timer_step__lwM6a","p1":"Timer_p1__azCMj","frame":"Timer_frame__qMQm0","video":"Timer_video__8I6td"};